import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5a44f7c2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "signature-description" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedModalHeader = _resolveComponent("FriedModalHeader");
    const _component_FriedTab = _resolveComponent("FriedTab");
    const _component_FriedParagraph = _resolveComponent("FriedParagraph");
    const _component_WriteSignature = _resolveComponent("WriteSignature");
    const _component_SignaturePad = _resolveComponent("SignaturePad");
    const _component_FriedButton = _resolveComponent("FriedButton");
    const _component_FriedModalButtonsFooter = _resolveComponent("FriedModalButtonsFooter");
    const _component_FriedModalSubContainer = _resolveComponent("FriedModalSubContainer");
    return (_openBlock(), _createBlock(_component_FriedModalSubContainer, { class: "verify-signature-container" }, {
        header: _withCtx(() => [
            (!_ctx.isSmallHeightMode)
                ? (_openBlock(), _createBlock(_component_FriedModalHeader, {
                    key: 0,
                    header: _ctx.t('signing')
                }, null, 8, ["header"]))
                : _createCommentVNode("", true)
        ]),
        footer: _withCtx(() => [
            _createVNode(_component_FriedModalButtonsFooter, { class: "action-buttons" }, {
                default: _withCtx(() => [
                    _createVNode(_component_FriedButton, {
                        class: "action-button",
                        "data-external": "verify-signing-modal-cancel-doc-btn",
                        "button-type": _ctx.ButtonType.Secondary,
                        onClick: _ctx.handleCancel
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('cancel')), 1)
                        ]),
                        _: 1
                    }, 8, ["button-type", "onClick"]),
                    _createVNode(_component_FriedButton, {
                        id: "sign",
                        "data-external": "verify-signing-modal-sign-doc-btn",
                        class: "action-button",
                        loading: _ctx.loading,
                        "button-type": _ctx.ButtonType.Branding,
                        disabled: !_ctx.signatureExists,
                        onClick: _ctx.handleSign
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.inEditor ? _ctx.t('sign') : _ctx.t('next')), 1)
                        ]),
                        _: 1
                    }, 8, ["loading", "button-type", "disabled", "onClick"])
                ]),
                _: 1
            })
        ]),
        default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", {
                class: _normalizeClass(['verify-signature-toggler', { disabled: _ctx.loading }])
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
                    return (_openBlock(), _createBlock(_component_FriedTab, {
                        key: tab.key,
                        value: tab.key,
                        "model-value": _ctx.activeTab,
                        "onUpdate:modelValue": _ctx.toggleSignatureType
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tab.label), 1)
                        ]),
                        _: 2
                    }, 1032, ["value", "model-value", "onUpdate:modelValue"]));
                }), 128))
            ], 2), [
                [_vShow, !!_ctx.entity.isSigningWrite]
            ]),
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_FriedParagraph, null, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('please_put_your_signature_in_the_box')), 1)
                    ]),
                    _: 1
                }),
                _createVNode(_component_FriedParagraph, null, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.signingInfoText), 1)
                    ]),
                    _: 1
                })
            ]),
            _createElementVNode("div", {
                class: _normalizeClass(['signature-container', { disabled: _ctx.loading, 'space-top': !_ctx.entity.isSigningWrite }]),
                "data-external": "signature-draw-container"
            }, [
                (!_ctx.drawSignatureIsActive && !!_ctx.entity.isSigningWrite)
                    ? (_openBlock(), _createBlock(_component_WriteSignature, {
                        key: 0,
                        assignee: _ctx.recipient,
                        onSignature: _ctx.handleWriteSignature
                    }, null, 8, ["assignee", "onSignature"]))
                    : (_openBlock(), _createBlock(_component_SignaturePad, {
                        key: 1,
                        class: _normalizeClass(['signature-pad', { 'small-height': _ctx.isSmallHeightMode }]),
                        onSignature: _ctx.handleDrawSignature,
                        onCancel: _ctx.handleCancel,
                        onSign: _ctx.handleSign,
                        onReset: _ctx.handleReset
                    }, null, 8, ["class", "onSignature", "onCancel", "onSign", "onReset"]))
            ], 2)
        ]),
        _: 1
    }));
}
